export default __webpack_public_path__ + "aec8871310c3a43016b395cc8fce0504.svg";